/* eslint-disable @angular-eslint/component-selector */

import { ChangeDetectionStrategy, Component, booleanAttribute, inject, input } from '@angular/core';
import { MatBadge } from '@angular/material/badge';
import { MatRipple } from '@angular/material/core';
import { MatIcon } from '@angular/material/icon';
import { CartComponentStore } from 'cart-data';
// import { CartService } from 'lib-cart';

@Component({
  selector: 'button[ideal-cart-menu-button]',
  standalone: true,
  imports: [MatRipple, MatIcon, MatBadge],
  templateUrl: './cart-menu-button.component.html',
  styleUrl: './cart-menu-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.open]': 'open() ? "" : null',
  },
})
export class CartMenuButtonComponent {
  private readonly _cartsStore = inject(CartComponentStore);
  public readonly open = input(false, { transform: booleanAttribute });
  public readonly itemCount = this._cartsStore.cartItemCount;
}
